/* global angular*/
import './style.less';

export default function($log, ApiClass, Swal) {
  'ngInject';

  const vm = this;

  vm.clear = () => {
    delete vm.email;
    delete vm.ngModel.email;
  };

  vm.submit = () => {
    const id = vm.eventId || vm.courseId;
    let type = 'progress';

    if (vm.eventId && vm.scormId) {
      type = 'scormAttendee';
    } else if (vm.eventId) {
      type = 'attendees';
    } else if (vm.scormId) {
      type = 'scormProgress';
    }

    vm.submitBtn = true;

    const validationApiFunction = vm.eventId ? ApiClass.eventsIdTypeTypeIdPost : ApiClass.coursesIdTypeTypeIdPost;

    return validationApiFunction({ id, type, type_id: vm.email })
      .then(({ data: { registered, email } }) => {
        if (registered) {
          vm.ngModel.email = email;
        } else {
          Swal.alert(
            undefined,
            'We were not able to find a registration for this event using the entered email address. Please double check the email address and try again. If the problem persists, please contact support@prolaera.com for further assistance.',
            'error'
          );
        }
        vm.submitBtn = false;
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/components/forms/validateRegistration/controller.js